import { SearchOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSubHeadings } from "../../../Store/B2bslice";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getRemittersByAccountXPay,
  getRemittersXPay,
  getRemittersXPayFusion,
  getVerifyRemitterXPay,
} from "../../../ApiServices/Apifun";
import { Button, Radio, Spin } from "antd";
import BeneficiaryCardxPayFusion from "./BeneficiaryCardxPayFusion";
import VerifyRemitterOtp from "../XPayout/VerifyRemitterOtp";

const GetRemitterxPayFusion = () => {
  const dispatch = useDispatch();
  const [mobile, setMobile] = useState("");
  const [account, setAccount] = useState("");

  const [type, setType] = useState("Bank");
  const [beneModal, setBeneModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [searchKeyword, setSearchKeyWord] = useState("");
  const [beneficiariesDetails, setbeneficiariesDetails] = useState([]);
  const [remitterName, setRemitterName] = useState("");
  const [showNameField, setShowNamefield] = useState(false);
  const [openOtpVerifyModal, setOpenVerifyOTPModal] = useState(false);
  const [remitterDetails, setremitterDetails] = useState({});
  const [isVerified, setIsVerified] = useState(null);
  useEffect(() => {
    dispatch(setSubHeadings(""));
  }, []);
  const handleChange = (e) => {
    const { value } = e.target;
    const sanitized = value.replace(/[^0-9]/g, "");
    const limitedNumbers = sanitized.slice(0, 10);
    setMobile(limitedNumbers);
    setShowNamefield(false);
    setBeneModal(false);
  };
  const handleChangeAccount = (e) => {
    const { value } = e.target;
    // const sanitized = value.replace(/[^0-9]/g, "");
    // const limitedNumbers = sanitized.slice(0, 10);
    setAccount(value);
  };
  const handleSearchByAccount = () => {
    setLoader(true);
    const formdata = new FormData();

    formdata.append("account_no", account);
    getRemittersByAccountXPay(formdata)
      .then((res) => {
        if (res.status) {
          setremitterDetails(res.data);
          // setbeneficiariesDetails(res.data?.beneficiaries);
          setBeneModal(true);
        } else {
          // console.log("comes in else condition");
          // setShowNamefield(true);
          setbeneficiariesDetails([]);
        }
      })
      .catch((err) => {
        console.log(err);
        setbeneficiariesDetails({});
      })
      .finally(() => setLoader(false));
  };
  const handleSearch = () => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("type", type);
    formdata.append("search_keyword", searchKeyword);
    formdata.append("mobile_number", mobile);
    getRemittersXPay(formdata)
      .then((res) => {
        if (res.status) {
          const data = res.data?.remitter;

          setremitterDetails(Array.isArray(data) ? data : [data]);

          setbeneficiariesDetails(res.data?.beneficiaries);
          setBeneModal(true);
          setIsVerified(true);
        } else {
          console.log("comes in else condition");
          setIsVerified(false);

          setbeneficiariesDetails([]);
        }
      })
      .catch((err) => {
        console.log(err);
        setbeneficiariesDetails([]);
      })
      .finally(() => setLoader(false));
  };
  const handleVerifyMobile = () => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("name", remitterName);
    formdata.append("mobile", mobile);
    getVerifyRemitterXPay(formdata)
      .then((res) => {
        if (res.status) {
          console.log("setOpenVerifyOTPModal");
          setOpenVerifyOTPModal(true);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoader(false));
  };
  useEffect(() => {
    if (searchKeyword?.length > 5) {
      handleSearch();
    }
  }, [searchKeyword]);

  return (
    <>
      <Spin spinning={loader}>
        <p className="font-bold text-xl">Remitter Search</p>

        <div className="mt-4 flex flex-col md:flex-row gap-4">
          {/* Mobile Search */}
          <div className="flex items-center w-full md:w-1/2 gap-2">
            <input
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter mobile number"
              className="h-12 w-full rounded-md bg-inputbg px-4"
            />
            <SearchOutlined
              onClick={() => mobile && handleSearch()}
              className={`w-10 h-10 rounded-full flex items-center justify-center
        ${mobile ? "bg-primary text-white cursor-pointer" : "bg-gray-300 cursor-not-allowed"}`}
            />
          </div>
          {/* Account Search */}
          <div className="flex items-center w-full md:w-1/2 gap-2">
            <input
              value={account}
              onChange={(e) => {
                setAccount(e.target.value);
                setMobile("");
                setremitterDetails([]);
                setbeneficiariesDetails([]);
              }}
              placeholder="Enter account number"
              className="h-12 w-full rounded-md bg-inputbg px-4"
            />
            <SearchOutlined
              onClick={() => account && handleSearchByAccount()}
              className={`w-10 h-10 rounded-full flex items-center justify-center
        ${account ? "bg-primary text-white cursor-pointer" : "bg-gray-300 cursor-not-allowed"}`}
            />
          </div>
        </div>
        {isVerified === false && (
          <div className="mt-4 flex flex-col md:flex-row gap-3 items-center">
            <input
              value={remitterName}
              onChange={(e) => setRemitterName(e.target.value)}
              placeholder="Enter remitter name"
              className="h-12 w-full rounded-md bg-inputbg px-4"
            />

            <Button
              // type="primary"
              disabled={!remitterName}
              onClick={handleVerifyMobile}
              className={` h-10 rounded-full flex items-center justify-center
        ${mobile ? "bg-primary text-white cursor-pointer" : "bg-gray-300 cursor-not-allowed"}`}
            >
              Verify Mobile
            </Button>
          </div>
        )}
        {/* <div className="rounded-md mt-2 px-2 h-14 md:w-1/2 flex justify-between items-center bg-inputbg">
          <Radio.Group
            onChange={(e) => setType(e.target.value)}
            value={type}
            className="flex gap-4 px-2"
          >
            <Radio value="Bank">Bank</Radio>
            <Radio value="UPI">UPI</Radio>
          </Radio.Group>
        </div> */}

        {beneModal && (
          <BeneficiaryCardxPayFusion
            handleSearch={handleSearch}
            mobile={mobile}
            account={account}
            type={type}
            apicall={handleSearch}
            searchKeyword={searchKeyword}
            setSearchKeyWord={setSearchKeyWord}
            beneficiariesDetails={beneficiariesDetails}
            setbeneficiariesDetails={setbeneficiariesDetails}
            remitterDetails={remitterDetails}
            isVerified={isVerified}
            setIsVerified={setIsVerified}
            setMobile={setMobile}
          />
        )}
        {openOtpVerifyModal && (
          <VerifyRemitterOtp
            handleSearch={handleSearch}
            mobile={mobile}
            name={remitterName}
            isOpen={openOtpVerifyModal}
            setIsOpen={setOpenVerifyOTPModal}
          />
        )}
      </Spin>
    </>
  );
};

export default GetRemitterxPayFusion;
